let getAccessTokenSilently: any = null;
let loginWithRedirect: any = null;
let logout: any = null;

export const sec = {
  getAccessTokenSilently: (): any => getAccessTokenSilently,
  // eslint-disable-next-line no-return-assign
  setAccessTokenSilently: (func: any): any => (getAccessTokenSilently = func),
  getLoginWithRedirect: (): any => loginWithRedirect,
  // eslint-disable-next-line no-return-assign
  setLoginWithRedirect: (func: any): any => (loginWithRedirect = func),
  getLogout: (): any => logout,
  // eslint-disable-next-line no-return-assign
  setLogout: (func: any): any => (logout = func),
};
